import Chart from 'react-apexcharts';
import { shortenNumber } from '../../utils/numberUtils';

const Charts = (props) => {
	console.log(props);

	const feesPaid = Array.isArray(props.feesPaid) ? props.feesPaid : [];
	const feesUnpaid = Array.isArray(props.feesUnpaid) ? props.feesUnpaid : [];

	const chartOptions = {
		series: [
			{
				name: 'Fees Paid',
				data: feesPaid.map((val) => (val != null ? val : 0)), // fallback to 0 if null
			},
			{
				name: 'Fees Due',
				data: feesUnpaid.map((val) => (val != null ? val : 0)), // fallback to 0 if null
			},
		],

		options: {
			colors: ['#09BD3C', '#FFAA2B'],
			chart: {
				toolbar: { show: false },
				background: 'transparent',
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				curve: 'smooth',
			},
			xaxis: {
				categories: ['pre-pri', 'pre-nur', 'nur', 'pri', 'sec'],
				labels: {
					style: {
						fontWeight: 700,
						color: ['#171B1E'],
						fontSize: '14px',
					},
				},
			},
			legend: {
				show: false,
			},
			grid: {
				borderColor: '#E4E4E4',
				xaxis: {
					lines: { show: true },
				},
				yaxis: {
					lines: { show: true },
				},
			},
			markers: {
				hover: {
					size: 9,
				},
			},
			yaxis: {
				labels: {
					formatter: (value) => shortenNumber(value),
					style: {
						fontSize: '14px',
						fontWeight: 500,
						colors: ['#787878'],
					},
				},
			},
		},
	};

	return (
		<div>
			<Chart
				options={chartOptions.options}
				series={chartOptions.series}
				type="line"
				height="350px"
				width="100%"
			/>
		</div>
	);
};

export default Charts;
